
import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import Navbar from "../../components/Navbar.js";
import Select from "react-select";
import LOGO from "../../assets/images/logo.png";
import {
    locale,
    tokens,
    select_style,
    required,
    // alert
    success,
    success_url,
    alert,
    alert_url,
    // function
    logout,
    number_zero,
    format_date,
    toFixed,
    total,
    validate,
    random_charactor,
    float,
    // api
    GET,
    POST,
    PUT,
    DELETE,
    error_message,
    // storage
    removeStorage,
    getStorage,

    validate_email,
    validate_th,
    validate_en,
    validate_en_number,

    LinktoBase64,
    // component
    DatePicker,
} from "../../components/CustomComponent.js";

import "../../components/global.js";
import "../../assets/css/bootstrap.css";
import "../../assets/css/index.css";

export default class Dashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            data: ["", ""]
        }
    }
    async componentDidMount() {
    }
    render() {
        return (
            <div className="w-100 min-vh-100 fade-in background-console">
                {this.state.loading && (<div className="spinner-container"> <div className="loading-spinner"></div> </div>)}
                <Navbar page1="หน้าหลัก" page2="จัดการระบบ" />
                {/* BODY */}
                <div className="body min-vh-100">
                    <div className="p-3">
                        {/* หัวข้อ และ ปุ่มเพิ่ม */}
                        <div className="d-flex row mx-0 align-items-center justify-content-between test text-center py-4">
                            <h3 className="mb-2"><b>จัดการระบบ</b></h3>
                        </div>
                        <div className="container">
                            <div className="card bg-white p-5 rounded-lg border-0">
                                <div className="row d-flex">
                                    <div className="wpx-150 hpx-150 me-3 mb-2 card pointer rounded-lg border-primary py-3 px-1 d-flex align-items-center justify-content-center hover-primary"
                                        onClick={() => { window.location.href = "/master/list-customer" }}
                                    >
                                        <div className="wpx-80 hpx-80 mb-2 rounded-circle bg-primary-light d-flex align-items-center justify-content-center text-primary">
                                            <span className="icon text-32">{"\uf007"}</span>
                                        </div>
                                        <label>ข้อมูลลูกค้า</label>
                                    </div>
                                    <div className="wpx-150 hpx-150 me-3 mb-2 card pointer rounded-lg border-primary py-3 px-1 d-flex align-items-center justify-content-center hover-primary"
                                        onClick={() => { window.location.href = "/master/list-role" }}
                                    >
                                        <div className="wpx-80 hpx-80 mb-2 rounded-circle bg-primary-light d-flex align-items-center justify-content-center text-primary">
                                            <span className="icon text-32">{"\uf0c0"}</span>
                                        </div>
                                        <label>บทบาท</label>
                                    </div>
                                    <div className="wpx-150 hpx-150 me-3 mb-2 card pointer rounded-lg border-primary py-3 px-1 d-flex align-items-center justify-content-center hover-primary"
                                        onClick={() => { window.location.href = "/master/list-admin" }}
                                    >
                                        <div className="wpx-80 hpx-80 mb-2 rounded-circle bg-primary-light d-flex align-items-center justify-content-center text-primary">
                                            <span className="icon text-32">{"\uf126"}</span>
                                        </div>
                                        <label>จัดการผู้ใช้งาน</label>
                                    </div>
                                </div>
                                <hr className="bg-primary mb-4" />
                                <div className="row d-flex">
                                    <div className="wpx-150 hpx-150 me-3 mb-2 card pointer rounded-lg border-primary py-3 px-1 d-flex align-items-center justify-content-center hover-primary"
                                        onClick={() => { window.location.href = "/master/list-warehouse" }}
                                    >
                                        <div className="wpx-80 hpx-80 mb-2 rounded-circle bg-primary-light d-flex align-items-center justify-content-center text-primary">
                                            <span className="icon text-32">{"\uf494"}</span>
                                        </div>
                                        <label>คลังสินค้า</label>
                                    </div>
                                    <div className="wpx-150 hpx-150 me-3 mb-2 card pointer rounded-lg border-primary py-3 px-1 d-flex align-items-center justify-content-center hover-primary"
                                        onClick={() => { window.location.href = "/master/list-category" }}
                                    >
                                        <div className="wpx-80 hpx-80 mb-2 rounded-circle bg-primary-light d-flex align-items-center justify-content-center text-primary">
                                            <span className="icon text-32">{"\uf468"}</span>
                                        </div>
                                        <label>หมวดหมู่สินค้า</label>
                                    </div>
                                    <div className="wpx-150 hpx-150 me-3 mb-2 card pointer rounded-lg border-primary py-3 px-1 d-flex align-items-center justify-content-center hover-primary"
                                        onClick={() => { window.location.href = "/master/list-spare-parts-repair" }}
                                    >
                                        <div className="wpx-80 hpx-80 mb-2 rounded-circle bg-primary-light d-flex align-items-center justify-content-center text-primary">
                                            <span className="icon text-32">{"\uf7d9"}</span>
                                        </div>
                                        <label>อะไหล่และการซ่อม</label>
                                    </div>
                                    <div className="wpx-150 hpx-150 me-3 mb-2 card pointer rounded-lg border-primary py-3 px-1 d-flex align-items-center justify-content-center hover-primary"
                                        onClick={() => { window.location.href = "/master/list-car" }}
                                    >
                                        <div className="wpx-80 hpx-80 mb-2 rounded-circle bg-primary-light d-flex align-items-center justify-content-center text-primary">
                                            <span className="icon text-32">{"\uf1b9"}</span>
                                        </div>
                                        <label>จัดการรถ</label>
                                    </div>
                                </div>
                                <hr className="bg-primary mb-4" />
                                <div className="row d-flex">
                                    <div className="wpx-150 hpx-150 me-3 mb-2 card pointer rounded-lg border-primary py-3 px-1 d-flex align-items-center justify-content-center hover-primary"
                                        onClick={() => { window.location.href = "/master/list-insurance" }}
                                    >
                                        <div className="wpx-80 hpx-80 mb-2 rounded-circle bg-primary-light d-flex align-items-center justify-content-center text-primary">
                                            <span className="icon text-32">{"\uf2f7"}</span>
                                        </div>
                                        <label>บริษัทประกัน</label>
                                    </div>
                                    <div className="wpx-150 hpx-150 me-3 mb-2 card pointer rounded-lg border-primary py-3 px-1 d-flex align-items-center justify-content-center hover-primary"
                                        onClick={() => { window.location.href = "/master/list-suppliers" }}
                                    >
                                        <div className="wpx-80 hpx-80 mb-2 rounded-circle bg-primary-light d-flex align-items-center justify-content-center text-primary">
                                            <span className="icon text-32">{"\uf1ad"}</span>
                                        </div>
                                        <label>บริษัทที่จำหน่าย</label>
                                    </div>
                                </div>
                                <hr className="bg-primary mb-4" />
                                <div className="row d-flex">
                                    <div className="wpx-150 hpx-150 me-3 mb-2 card pointer rounded-lg border-primary py-3 px-1 d-flex align-items-center justify-content-center hover-primary"
                                        onClick={() => { window.location.href = "/master/barcode" }}
                                    >
                                        <div className="wpx-80 hpx-80 mb-2 rounded-circle bg-primary-light d-flex align-items-center justify-content-center text-primary">
                                            <span className="icon text-32">{"\uf02a"}</span>
                                        </div>
                                        <label>จัดการ Barcode</label>
                                    </div>
                                    <div className="wpx-150 hpx-150 me-3 mb-2 card pointer rounded-lg border-primary py-3 px-1 d-flex align-items-center justify-content-center hover-primary"
                                        onClick={() => { window.location.href = "/master/print-barcode" }}
                                    >
                                        <div className="wpx-80 hpx-80 mb-2 rounded-circle bg-primary-light d-flex align-items-center justify-content-center text-primary">
                                            <span className="icon text-32">{"\uf02f"}</span>
                                        </div>
                                        <label>พิมพ์ Barcode</label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}
